// extracted by mini-css-extract-plugin
export default {"cardContainer":"CylinderStats_cardContainer__vabDz","card":"CylinderStats_card__zKTFk"};